import React from "react";
import ModalDialog, { DialogContent } from '../../AlmeDialog/ModalDialog';
import styled from "styled-components";
import Button from "syf-component-library/ui/atoms/Button";
import { focusMessageBox } from "../../AlmeUtilities/dom-utils";
const CloseSurveyLink = styled(Button) `
        float:right;
        color: ${({ theme }) => theme.button.text};
        padding: 10px !important;
        text-transform: none !important;        
        &:after { 
                    content: "\\2716";
                    padding-left: 5px;
                }
`;
const SurveyDialogContent = styled(DialogContent) `
    padding: 0;
    margin: 0;
    overflow-x: hidden;
`;
const SurveyIframe = styled.iframe `
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    flex-grow: 1;
`;
const IframeContainer = styled.div `
display: flex;
flex-direction: row;
align-items: stretch;
flex-grow: 1;
overflow: hidden;
`;
const AlmeOverlaySurveyDialog = (props) => {
    const handleSurveyClose = () => {
        props.onCloseSurvey(true);
        focusMessageBox();
    };
    return (React.createElement(React.Fragment, null, props.isOpen
        ? React.createElement(ModalDialog, { id: 'survey-overlay-dialog', ariaLabel: 'Live chat survey dialog', style: { width: "100%", height: "inherit" } },
            React.createElement(SurveyDialogContent, null,
                React.createElement("div", null,
                    React.createElement(CloseSurveyLink, { buttonType: "text", id: "close-survey-button", "data-testid": "close-survey-overlay-dialog-link", onClick: handleSurveyClose, ariaLabel: "Close Survey" }, "Close Survey")),
                React.createElement(IframeContainer, null,
                    React.createElement(SurveyIframe, { title: "SurveyOverlay", src: props.surveyURL }))),
            React.createElement("input", { type: 'button', "aria-hidden": "true", style: { opacity: 0 } }))
        : null));
};
export default AlmeOverlaySurveyDialog;
